import { getQueryString }  from '../../helpers';
import PROPERTY_SEARCH_FIELD_TYPES from '@assets/data/property-search-field-types';


/**
 * Initial Coords to Center the Map On
 */
export const updateLat = (state, payload) => { state.lat = payload; };
export const updateLng = (state, payload) => { state.lng = payload; };

export const updateInitialized = (state, payload) => { state.initialized = payload; };
export const updateAppState = (state, payload) => { state.appState = payload; };
export const updateErrors = (state, payload) => { state.errors = payload; };
export const updatePropertyMapState = (state, payload) => { state.propertyMapState = payload; };
export const updateSearchType = (state, payload) => { state.searchType = payload; };
export const updateFieldGroups = (state, payload) => { state.fieldGroups = payload; };
export const updateMarkers = (state, payload) => { state.markers = payload; };
export const updateProperties = (state, payload) => { state.properties = payload; };
export const updateMlsPhotos = (state, payload) => { state.mls_photos = payload };
export const updateListings = (state, payload) => { state.listings = payload; };
export const clearHighlightedProperty = (state, payload) => { state.highlightedProperty = {}; };
export const updateSelectedLocation = (state, payload) => { state.selectedLocation = payload; };
export const updateSelectedMarket = (state, payload) => { state.selectedMarket = payload; };
export const updateSelectedCounty = (state, payload) => state.selectedCounty = payload;
export const updateTotalCnt = (state, payload) => { state.totalCnt = payload; };
export const updateLocationChanging = (state, payload) => { state.locationChanging = payload; }; // This flag is used to allow the map to trigger new results to be queried when a new location is selected. There is a system in place to prevent requests from going out on mnobile when the map is not visible, due to unpredictable browser resize events happening on mobile (user scrolls down the page, header goes fixed, the map changes size causing a map bounds change, and new reqiuest to the API)
export const updateManageType = (state, payload) => { state.manageType = payload; };
export const updateManageMode = (state, payload) => { state.manageMode = payload; };
export const toggleMapView = (state) => state.mapView *= -1;
export const updateHighlightedProperty = (state, payload) => { state.highlightedProperty = payload; };
export const updateMobileMode = (state, payload) => { state.mobileMode = payload; };
export const updateMlsDisclaimerText = (state, text) => state.mlsDisclaimerText = text;
export const updateMlsDisclaimersTextList = (state, disclaimers) => state.mlsDisclaimersTextList = disclaimers;
export const updateMlsDisclaimers = (state, disclaimers) => state.mlsDisclaimers = disclaimers;
export const updateBrokerageFootersList = (state, footers) => state.brokerageFootersList = footers;
export const updateMlsNames = (state, names) => state.mlsNames = names;

export const updateMlsName = (state, text) => state.mlsName = text;
export const updateMapConfigZoom = (state, payload) => { state.mapConfig.zoom = payload; };
export const updateMapConfigCenter = (state, payload) => { state.mapConfig.center = payload; };
export const addFiltersDrawerMobileFieldGroups = (state, payload) => { 
  state.fieldGroups.size.push('max_beds');
  state.fieldGroups.size.push('min_beds');
  state.fieldGroups.financials.push('max_asking_price');
  state.fieldGroups.financials.push('min_asking_price');
  state.fieldGroups.financials.push('max_gross_yield');
  state.fieldGroups.financials.push('min_gross_yield');
};
export const updateMapConfig = (state, payload) => { state.mapConfig = { ...state.mapConfig, ...payload }; };


// Object Merges
export const updateSearchParams = (state, payload) => { state.searchParams = { ...state.searchParams, ...payload }; };
export const updateSavedPropertySearch = (state, payload) => { state.savedPropertySearch = { ...state.savedPropertySearch, ...payload }; };



// Special
export const updateQueryString = ( state, searchType ) => {
  var str = [];
    
  let params = {...state.searchParams};
  let fieldsToSkip = [];
  // if(searchType == 'for-rent'){
  //   fieldsToSkip = [
  //     //'min_asking_price',
  //     //'max_asking_price',
  //   ];
  // } else if(searchType == 'for-sale'){
  //   fieldsToSkip = [
  //     // api is only worried about min_price and max_price
  //     'min_rent_amt', 
  //     'max_rent_amt'
  //   ];
  // }
  
  // let fieldTypes = PROPERTY_SEARCH_FIELD_TYPES;

  // fieldTypes.pct.map((field) => {
  //   if(params[field]){
  //     params[field] = params[field] / 100;
  //   }
  // })


  state.queryString = getQueryString(params, fieldsToSkip);
};


export const updateMlsDisclaimer = (state, payload) => {
  if(!payload.mls) return false;
  if(!payload.text) return false;
  state.mlsDisclaimers[payload.mls] = payload.text;
};